import * as React from "react";
const SvgFiRrMango = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-mango_svg__a)">
      <path
        fill="#062147"
        d="M18.5 11a1.5 1.5 0 1 1-.001 3.001 1.5 1.5 0 0 1 .001-3m-3 7A1.5 1.5 0 1 0 15.499 15 1.5 1.5 0 0 0 15.5 18M14.283 1.671A1.004 1.004 0 0 1 14.305.26a1 1 0 0 1 1.406.012c.054.054.796.851 1.422 2.323.192-.295.414-.58.675-.84C18.987.573 20.601.156 21.748.014a1.98 1.98 0 0 1 1.664.572c.44.44.648 1.047.572 1.664-.142 1.147-.559 2.761-1.737 3.94-1.668 1.668-4.229 1.81-5.044 1.81C16 8 16 7.006 16 7c0-3.497-1.646-5.256-1.717-5.33m3.771 4.274c.829-.1 1.995-.385 2.778-1.168.777-.777 1.063-1.937 1.167-2.772v-.003c-.841.102-2 .39-2.777 1.166-.782.782-1.067 1.948-1.168 2.777m5.697 3.833a1 1 0 0 0-1.95.442c.131.58.198 1.178.198 1.78 0 8.788-8.583 10-17.857 10-1.162 0-2.143-1.004-2.143-2.19 0-.425.123-.834.316-1.13.031-.036.24-.255 1.312-1.108 1.596-1.27 2.372-3.094 2.372-5.573a7.954 7.954 0 0 1 6.221-7.802 1 1 0 1 0-.442-1.95C7.198 3.287 3.999 7.297 3.999 12c0 1.855-.514 3.13-1.618 4.008C1.032 17.081.812 17.334.69 17.518A4.12 4.12 0 0 0 0 19.81C0 22.12 1.858 24 4.143 24 10.588 24 24 24 24 12c0-.75-.083-1.497-.248-2.22z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-mango_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMango;
